<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { BUSINESS_TYPES, SEGMENTS } from '../constants/segments.js';

const props = defineProps({
  businessType: { type: String, required: true },
  segmentId: { type: String, required: true },
});

const emit = defineEmits(['update:businessType', 'update:segmentId']);

const { t } = useI18n();

const segments = computed(() => SEGMENTS[props.businessType] || []);

const selectBusinessType = id => {
  emit('update:businessType', id);
  emit('update:segmentId', 'outros');
};
</script>

<template>
  <div class="flex flex-col gap-5">
    <div class="flex flex-col gap-2">
      <p class="text-sm font-medium text-n-slate-12">
        {{ t('QUICK_SETUP.STEP_BUSINESS.TYPE_LABEL') }}
      </p>
      <div class="grid grid-cols-2 gap-3">
        <button
          v-for="type in BUSINESS_TYPES"
          :key="type.id"
          type="button"
          class="rounded-lg border p-4 text-left text-sm font-medium transition-colors"
          :class="
            businessType === type.id
              ? 'border-n-blue-9 bg-n-blue-3 text-n-blue-11'
              : 'border-n-weak text-n-slate-12 hover:border-n-blue-6'
          "
          @click="selectBusinessType(type.id)"
        >
          {{ type.label }}
        </button>
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <p class="text-sm font-medium text-n-slate-12">
        {{ t('QUICK_SETUP.STEP_BUSINESS.SEGMENT_LABEL') }}
      </p>
      <div class="grid grid-cols-2 gap-3">
        <button
          v-for="segment in segments"
          :key="segment.id"
          type="button"
          class="rounded-lg border p-3 text-left text-sm transition-colors"
          :class="
            segmentId === segment.id
              ? 'border-n-blue-9 bg-n-blue-3 text-n-blue-11'
              : 'border-n-weak text-n-slate-12 hover:border-n-blue-6'
          "
          @click="emit('update:segmentId', segment.id)"
        >
          {{ segment.label }}
        </button>
      </div>
    </div>
  </div>
</template>
